// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"388":"b3940f9b","556":"fd586597","770":"e5b4e864","890":"71fedb3c"}[chunkId] + ".chunk.js";
};